module.exports = "/* 一時保存ボタン（fixed） */\r\n.temp-btn {\r\n    position: fixed;\r\n    bottom: 2px;\r\n    left: 10px;\r\n    font-size: 77%;\r\n    z-index: 1;\r\n    cursor: pointer;\r\n    font-weight: 700;\r\n    padding: 10px ;\r\n    border-radius: 7px;\r\n}\r\n.temp-btn:hover{\r\n    background-color: argb(0, 0, 0, .2);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/b0102-answer/b0102-answer.component.css
// module id = ./src/app/b0102-answer/b0102-answer.component.css
// module chunks = main